module.exports = __webpack_public_path__ + "static/media/Fetch location icon.f4f909ed.png";